import { IFilter } from "@saleor/components/Filter";
import { FilterOpts } from "@saleor/types";
import { SmopStatusEnum } from "@saleor/types/globalTypes";
import { createOptionsField } from "@saleor/utils/filters/fields";
import { defineMessages, IntlShape } from "react-intl";

export enum MallFilterKeys {
  status = "status"
}

export interface MallListUrlFiltersOpts {
  status: FilterOpts<SmopStatusEnum>;
}

const messages = defineMessages({
  active: {
    defaultMessage: "Active",
    description: "Active Mall"
  },
  deleted: {
    defaultMessage: "Deleted",
    description: "Delete Mall"
  },
  inactive: {
    defaultMessage: "Inactive",
    description: "Deactivated Mall"
  },
  status: {
    defaultMessage: "Status",
    description: "Mall Status"
  }
});

export function createFilterStructure(
  intl: IntlShape,
  opts: MallListUrlFiltersOpts
): IFilter<MallFilterKeys> {
  return [
    {
      ...createOptionsField(
        MallFilterKeys.status,
        intl.formatMessage(messages.status),
        [opts.status.value],
        false,
        [
          {
            label: intl.formatMessage(messages.active),
            value: SmopStatusEnum.ACT
          },
          {
            label: intl.formatMessage(messages.inactive),
            value: SmopStatusEnum.INA
          },
          {
            label: intl.formatMessage(messages.deleted),
            value: SmopStatusEnum.DEL
          }
        ]
      ),
      active: opts.status.active
    }
  ];
}
